export default __webpack_public_path__ + "static/media/783.f84a221e.gif";